'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './radio.module.scss';
const defaultOnInvalid = (e)=>{
    e.preventDefault();
};
export const Radio = ({ className, checked, onInvalid, ...props })=>/*#__PURE__*/ _jsxs("span", {
        className: classNames(styles.wrapper, className),
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "radio",
                checked: checked,
                onInvalid: onInvalid ?? defaultOnInvalid,
                ...props,
                className: classNames(styles.radio)
            }),
            /*#__PURE__*/ _jsx("span", {
                className: classNames(styles.circle, checked && styles.checked)
            })
        ]
    });

//# sourceMappingURL=index.js.map